import styled from "styled-components";

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
`;

const Subtitle = styled.div`
  color: var(--element);
  font-size: 15px;
  font-weight: 900;
  /* color: var(--accentColor); */
  color: var(--element);
  margin: 0;
  padding: 0;

  text-transform: uppercase;
  font-family: var(--headingFont);
  /* margin-bottom: 10px; */
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 800;

  /*  */
  font-weight: 800;

  font-family: var(--headingFont);
  text-transform: capitalize;
  font-size: 13px;
`;

export default function DetailsSection({ title, children }) {
  return (
    <Section>
      <Subtitle>{title}</Subtitle>
      <SectionContent>{children}</SectionContent>
    </Section>
  );
}
